<div class="ms-3">
  <h4 translate="VIRKESKOP_ANBUD_KONTRAKT_TILLAGDA_FILER"></h4>
  <div class="d-flex">
    @if (fileUploadError.length > 0) {
      <div class="alert alert-danger pa-3" role="alert">
        {{fileUploadError}}
      </div>
    }
  </div>
  <div class="d-flex form-spacing pb-3">
    <div class="col-9 ">
      <rask-file-upload
        accept=".txt,.pdf,.xlsx,.xls,.doc,.docx,.msg,.jpg,.jpeg,.png"
        (fileChange)="onFileSelected(upload.files)"
        [disabled]="!hasUploadFilePermission"
        [multiple]="multiple"
        #upload
        class="file-input-box">
        <span class="my-auto">
          @if(!isForKontrakt && atgardId > 0){
            {{ fileName || placeholderText}}
          }
          @else{
          För att kunna lägga till filer måste kontraktet först sparas
        }
      </span>
    </rask-file-upload>
  </div>
  <div class="col-2">
    <button type="button" class="btn btn-primary" [disabled]="uploadButtonInactive || readonly"
      (click)="uploadDocument()"
    translate="VIRKESKOP_ANBUD_KONTRAKT_TILLAGDA_FILER_LADDA_UP"></button>
  </div>
</div>
<div class="col-10">
  @if (dokument.length > 0) {
    <ul class="pb-5">
      @for (dok of dokument; track dok) {
        <li>
          <div>
            <div [ngbTooltip]="deleteToolTip" class="float-end">
              @if (hasEditFilePermission && deleteFileEnabled) {
                <rask-button [disabled]="fileActionInProgress || readonly || isLastFileDeletionDisabled"
                  type="button" class="remove-button"
                  icon="far fa-trash-alt" color="tertiary"
                  (click)="deleteDokument(dok)" negative>
                </rask-button>
              }
            </div>
            @if (hasEditFilePermission) {
              <a
                href="javascript:void(0)"
                (click)="openBilaga(dok.virkeskopskontraktId, dok.id)"
                class="fw-bold">{{dok.filnamn}}</a>
                <a href="javascript:void(0)" (click)="downloadDokument(dok)"
                    class="btn btn-lg btn-icon" title="Ladda ner dokumentet">
                    <span class="fas fa-download fa-xs"></span>
                </a>
            } @else {
              <div class="fw-bold file-locked">{{dok.filnamn}}</div>
            }
            <br />
            <span>Version {{ dok.version }} | {{ dok.skapadTidpunkt | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
          </div>
        </li>
      }
    </ul>
  }
</div>
</div>